import { ActiveSheetData } from 'src/components/viewers/SheetsViewerV2/hooks/useActiveSheet';
import { PolygonShape } from 'src/components/viewers/SheetsViewerV2/shapes/PolygonShape';
import Viewer3D = Autodesk.Viewing.Viewer3D;
import GuiViewer3D = Autodesk.Viewing.GuiViewer3D;
import Edit2D = Autodesk.Extensions.Edit2D;
import { SheetFillStyleSet } from 'src/components/viewers/SheetsViewerV2/shapes/abstract/AbstractSheetFilledShape';

export function mapPointsToPolygonShape(
  pointsArray: THREE.Vector3[][],
  viewer: Viewer3D | GuiViewer3D,
  edit2d: Edit2D,
  activeSheetData: ActiveSheetData,
  styleSet?: SheetFillStyleSet
) {
  if (!pointsArray || !pointsArray.length) {
    return [];
  }

  const exteriorPoints = pointsArray[0].length ? pointsArray[0] : null;
  const interiors = [...pointsArray]
    .slice(1, pointsArray.length)
    .filter((points) => Array.isArray(points) && points.length > 0)
    .map((points) => ({ points }));

  if (!exteriorPoints) {
    return [];
  }

  return [
    new PolygonShape(
      viewer,
      edit2d,
      activeSheetData,
      undefined,
      [{ exterior: { points: exteriorPoints }, interiors: interiors }],
      styleSet
    ),
  ];
}
